export class AddressModel{
  country:string;
  countryCode:string;
  city:string;
  zipCode:number;
  address:string;
  houseNumber:string;
}
